<template>
  <div :key="key" class="dashboard-chart">
    <h4 class="titulo">Rentabilidad Neta</h4>
    <!-- <h4 :class="totalNegocio ? 'titulo' : ''">Rentabilidad Neta</h4>
    <p v-if="totalNegocio" class="subtitulo">Incluye reembolsos</p> -->
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorRentabilidadNetaValue"
      :separator-step="parseInt(0)"
      :min="indicadorRentabilidadNetaMin"
      :max="indicadorRentabilidadNetaMax"
      :gauge-color="indicadorRentabilidadNetaColor"
      :scale-interval="10"/>
    <chart-avance :pjeAvance="indicadorPjeAvancePeriodo" />
    <div class="dashboard-chart-text">
      <p>Objetivo: {{ indicadorRentabilidadNetaObjetivo | numero(2, true) }} %</p>
      <p>Rentabilidad: {{ indicadorRentabilidadNetaValue | numero(2, true) }} %</p>
      <p>Rent.Anual: {{ indicadorRentabilidadNetaAnualValue | numero(2, true) }} %</p>
      <p class="description">{{ indicadorRentabilidadNetaDescripcion }}</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';
import ChartAvance from './ChartAvance.vue';

export default {
  components: {
    VueSvgGauge,
    ChartAvance
  },
  props: {
    totalNegocio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorRentabilidadNetaColor: [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      // indicadorRentabilidadNetaColor: [
      //   { offset: 0, color: '#E46651' },
      //   { offset: 20, color: '#41B883' },
      //   { offset: 100, color: '#41B883' }
      // ],
      indicadorRentabilidadNetaMin: 0,
      indicadorRentabilidadNetaMax: 100,
      indicadorRentabilidadNetaObjetivo: 0,
      indicadorRentabilidadNetaValue: 0,
      indicadorRentabilidadNetaAnualValue: 0,
      indicadorRentabilidadNetaDescripcion: '',
      indicadorPjeAvancePeriodo: 0,
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      let dispatch = 'resultadosRentabilidadNeta/getIndicadorRentabilidadNetaSemestral';
      let getter = 'resultadosRentabilidadNeta/indicadorRentabilidadNetaSemestral';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosRentabilidadNeta/getIndicadorRentabilidadNetaSemestralTotal';
        getter = 'resultadosRentabilidadNeta/indicadorRentabilidadNetaSemestralTotal';
      }

      this.$store.dispatch(dispatch)
        .then(() => {
          let indicador = this.$store.getters[getter];

          this.indicadorRentabilidadNetaObjetivo = parseFloat(indicador.pjeObjetivo);
          this.indicadorRentabilidadNetaValue = indicador.pjeRentabilidad;
          this.indicadorRentabilidadNetaAnualValue = indicador.pjeRentabilidadAnual;
          this.indicadorRentabilidadNetaDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          // this.indicadorRentabilidadNetaDescripcion = indicador.descripcion? indicador.descripcion.trim() : '';

          /* Si supera el objetivo, actualizamos el color del indicador */
          if ( parseFloat(this.indicadorRentabilidadNetaValue) >= parseFloat(this.indicadorRentabilidadNetaObjetivo)) {
            this.indicadorRentabilidadNetaColor = [ { offset: 0, color: this.verde }, { offset: 100, color: this.verde } ];
          } else if ( parseFloat(this.indicadorRentabilidadNetaValue) >= (parseFloat(this.indicadorRentabilidadNetaObjetivo) / parseFloat(2))) {
            this.indicadorRentabilidadNetaColor = [ { offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo } ];
          }

          this.indicadorPjeAvancePeriodo = indicador.pjeAvancePeriodo;
        })
        .finally(() => this.key++);
    },
    cancelar() {
      this.$store.dispatch('resultadosRentabilidadNeta/cancelarIndicadorRentabilidadNetaSemestral');
    }    
  }
}
</script>

<style>
</style>


